import React, { FC } from 'react'

type IconProps = {
  className?: string
  size?: number
}

export const PlayIcon: FC<IconProps> = ({ className, size = 21 }) => {
  return (
    <svg
      className={className}
      fill={'none'}
      height={size}
      viewBox={'0 0 20 21'}
      width={size}
      xmlns={'http://www.w3.org/2000/svg'}
    >
      <path
        d={
          'M6.75 15.9863L15.75 10.4863L6.75 4.98633V15.9863ZM6 3.70508C6.46875 3.42383 7.0625 3.42383 7.53125 3.70508L16.5312 9.20508C16.9688 9.48633 17.25 9.98633 17.25 10.4863C17.25 11.0176 16.9688 11.5176 16.5312 11.7676L7.53125 17.2676C7.0625 17.5801 6.46875 17.5801 6 17.2988C5.53125 17.0488 5.25 16.5488 5.25 15.9863V4.98633C5.25 4.45508 5.53125 3.95508 6 3.70508Z'
        }
        fill={'currentColor'}
      />
    </svg>
  )
}
